import axios from "axios";

const instance = axios.create({
    baseURL: "/api",
    timeout: 5000,
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
});

instance.interceptors.response.use(

  	response => response, error => {

        const originalRequest = error.config;
        if(originalRequest?._isLoginRequest) return Promise.reject(error);

		//

    	const status = error.response?.status;
    	if(status === 401) window.location.href = '/login';

    	return Promise.reject(error);
  	}
);

export default instance; 